// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkout-bidding[data-v-a91ac8c2]{display:flex;flex-direction:column;gap:1rem;margin-bottom:15px}.checkout-bidding__input[data-v-a91ac8c2]{margin-left:auto;text-align:right;width:200px}.checkout-bidding__low-hint[data-v-a91ac8c2]{text-wrap:pretty;display:flex;gap:1rem}.checkout-bidding__low-hint-icon[data-v-a91ac8c2]{flex:1 0 auto;font-size:1.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
